import { useRef, useEffect, useLayoutEffect, useContext } from 'react'
import { CollectionContext } from '../../state/CollectionContext'
import style from './comments.module.css'
import globalStyle from '../../styles/common.module.css'
import { findSelectedChunk } from '../../state/util'
import { Chunk, UserComment } from '../../state/types'


export function UserComments() {
  const context = useContext(CollectionContext)
  const story = context.state.find((story) => story.isActive)
  if (!story) return null

  const selectedChunk = findSelectedChunk(story)
  const chunksWithUserComments = story.content.flat().filter((chunk) => chunk.userComment)

  return (
    <div className={[style.comments, globalStyle.grid3].join(' ')}>
      {
        selectedChunk
        &&
        <Comment
          item={selectedChunk}
          isActive={true}
          key={`comment-${selectedChunk.id}`}
        />
      }

      {
        chunksWithUserComments.map((chunk) => {
          return (
            chunk.id !== selectedChunk?.id
            &&
            <Comment
              item={chunk}
              isActive={false}
              key={`comment-${chunk.id}`}
            />
          )
        })
      }
    </div>
  )
}

function Comment({ item, isActive }: { item: Chunk, isActive: boolean }) {
  const context = useContext(CollectionContext)
  const inputField = useRef<HTMLTextAreaElement>(null)


  useLayoutEffect(() => {
    if (inputField.current) {
      const el = inputField.current
      inputField.current.scrollTo({ top: 0, behavior: 'smooth' })
      el.focus()
      el.setSelectionRange(el.value.length, el.value.length)
    }
  }, [])


  return (
    <div className={style.comment}>
      <p className={[style.selection, globalStyle.subtitle].join(' ')}>
        &ldquo;{item.text}&rdquo;
      </p>

      <div className={style.wrapper}>
        {isActive ? (
          <textarea
            className={[style.textarea, globalStyle.bodySM].join(' ')}
            ref={inputField}
            defaultValue={item.userComment || ''}
            placeholder='Add a comment...'
          />
        ) : (
          <p
            className={[globalStyle.bodySM, style.commentBody].join(' ')}
            onClick={() =>
              context.dispatch({
                type: 'select_chunk',
                chunkId: item.id,
              })
            }
          >
            {item.userComment}
          </p>
        )}

        <div className={style.buttons}>
          {isActive && (
            <button
              className={[
                globalStyle.button,
                globalStyle.light,
                globalStyle.narrow,
                globalStyle.buttonSM,
              ].join(' ')}
              onClick={() => {
                context.dispatch({
                  type: 'add_user_comment',
                  comment: inputField.current?.value || '',
                  chunkId: item.id,
                })
              }}
            >
              Add
            </button>
          )}

          <button
            className={[
              globalStyle.button,
              globalStyle.clear,
              globalStyle.narrow,
              globalStyle.buttonSM,
            ].join(' ')}
            onClick={() =>
              context.dispatch({
                type: 'remove_user_comment',
                chunkId: item.id,
              })
            }
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  )
}